import React, { useCallback, useState } from "react";
import ConfirmDialog from "./ConfirmDialog";

// Sluitbewaking voor dialogen met bewerkbare inhoud (Modal/Drawer prop `dirty`).
//
// Geeft [requestClose, guard] terug: roep requestClose aan i.p.v. onClose (Esc, overlay,
// ×-knop). Is `dirty` waar, dan verschijnt eerst "Wijzigingen weggooien?"; pas na
// bevestigen volgt onClose. Render `guard` naast de dialoog.
export default function useDiscardGuard(dirty, onClose) {
  const [asking, setAsking] = useState(false);

  const requestClose = useCallback(() => {
    if (!onClose) return;
    if (dirty) setAsking(true);
    else onClose();
  }, [dirty, onClose]);

  const guard = (
    <ConfirmDialog
      open={asking}
      title="Wijzigingen weggooien?"
      message="Je wijzigingen zijn nog niet opgeslagen en gaan verloren."
      confirmLabel="Weggooien"
      cancelLabel="Verder bewerken"
      tone="danger"
      onConfirm={() => {
        setAsking(false);
        onClose?.();
      }}
      onCancel={() => setAsking(false)}
    />
  );

  return [onClose ? requestClose : undefined, guard];
}
